import styled from "styled-components";

export const StyledData = styled.div`
    font-size: var(--size-14);
    line-height: 24px;
    font-style: normal;
    color: var(--color-grey-900);
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    line-break: anywhere;

    svg {
        flex: none;
    }
`;

export default StyledData;
